/* Signal Relief 2026 — mega menu behaviour
   Hover (with a small intent delay), keyboard focus, Escape, touch-first-tap,
   and click-outside. Leaves Motion's header JS untouched. */
(function () {
  'use strict';

  var OPEN_DELAY = 70;
  var CLOSE_DELAY = 160;
  var root = document.documentElement;
  var lastPointer = 'mouse';

  function init() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-sr-mega-item]'));
    if (!items.length) return;

    var openItem = null;
    var openTimer = null;
    var closeTimer = null;

    function setOpen(item, open) {
      var link = item.querySelector('.sr-nav__link');
      item.classList.toggle('is-open', open);
      if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function open(item) {
      clearTimeout(closeTimer);
      if (openItem && openItem !== item) setOpen(openItem, false);
      openItem = item;
      setOpen(item, true);
      root.classList.add('sr-mega-open');
    }

    function close(item) {
      if (!item) return;
      setOpen(item, false);
      if (openItem === item) openItem = null;
      if (!openItem) root.classList.remove('sr-mega-open');
    }

    function closeAll() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      items.forEach(function (item) { setOpen(item, false); });
      openItem = null;
      root.classList.remove('sr-mega-open');
    }

    document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);

    items.forEach(function (item) {
      var link = item.querySelector('.sr-nav__link');

      item.addEventListener('mouseenter', function () {
        if (lastPointer === 'touch') return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(item); }, openItem ? 0 : OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        if (lastPointer === 'touch') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { close(item); }, CLOSE_DELAY);
      });

      item.addEventListener('focusin', function () { open(item); });

      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });

      if (link) {
        // First tap on touch opens the panel; a second tap follows the link.
        link.addEventListener('click', function (e) {
          if (lastPointer === 'touch' && !item.classList.contains('is-open')) {
            e.preventDefault();
            open(item);
          }
        });

        // Down arrow moves into the panel.
        link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            var first = item.querySelector('.sr-mega a');
            if (first) {
              e.preventDefault();
              open(item);
              first.focus();
            }
          }
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openItem) return;
      var link = openItem.querySelector('.sr-nav__link');
      closeAll();
      if (link) link.focus();
    });

    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) closeAll();
    });

    // Opening the search, cart or mobile drawer should close any open panel.
    document.addEventListener('drawerOpen', closeAll);
    document.querySelectorAll('.js-search-header').forEach(function (el) {
      el.addEventListener('click', closeAll);
    });

    var mq = window.matchMedia('(min-width: 1024px)');
    var onChange = function () { if (!mq.matches) closeAll(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    // Theme editor: show a block's panel while it is selected.
    document.addEventListener('shopify:block:select', function (e) {
      var item = e.target && e.target.closest ? e.target.closest('[data-sr-mega-item]') : null;
      if (item) open(item);
    });
    document.addEventListener('shopify:block:deselect', closeAll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
